/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M5 1c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1v2.5h3.25c.9665 0 1.75.7835 1.75 1.75V17c0 .9665-.7835 1.75-1.75 1.75h-4.9289l-5.1797 5.1796a.1998.1998 0 0 1-.2828 0L6.679 18.75H1.75C.7835 18.75 0 17.9665 0 17V5.25C0 4.2835.7835 3.5 1.75 3.5H5V1Zm1.5 6V1.5h11V7h-11Zm.25 10.25 5.1086-5.1086a.2.2 0 0 1 .2828 0L17.25 17.25h5a.25.25 0 0 0 .25-.25V5.25a.25.25 0 0 0-.25-.25H19v2.5c0 .5523-.4477 1-1 1H6c-.5523 0-1-.4477-1-1V5H1.75a.25.25 0 0 0-.25.25V17a.25.25 0 0 0 .25.25h5ZM12 21.9497l-3.9142-3.9142L12 14.1213l3.9142 3.9142L12 21.9497Z"
    clipRule="evenodd"
  />,
  'EntityDiagram'
);
